import React from 'react';
import { FormattedMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';

import { holdItemShape } from '@bibliocommons/bc-prop-types';
import AvailabilityBibBlock from '@bibliocommons/availability-bib-block';
import ItemField from '../../shared/ItemField';
import ItemFormat from '../../../shared/ItemFormat';

import './HoldsAdditionalBriefInfo.scss';

export default class HoldsAdditionalBriefInfo extends BcReactComponent {
  renderVolume() {
    const volume = this.props.item.get('volume');
    return volume && (
      <ItemField className="volume-field" name={<FormattedMessage id="volume" />} value={volume} />
    );
  }

  renderCopy() {
    const copy = this.props.item.get('copy');
    return copy && (
      <ItemField className="copy-field" name={<FormattedMessage id="copy" />} value={copy} />
    );
  }

  renderItemDetails() {
    const additionalTitleText = this.props.item.get('additionalTitleText');
    return additionalTitleText && (
      <ItemField className="item-details-field" name={<FormattedMessage id="item_details" />} value={additionalTitleText} />
    );
  }

  isOnOrder() {
    const availabilityStatus = this.props.item.getIn(['bib', 'availability']);
    const status = availabilityStatus.get('status') || availabilityStatus.get('localisedStatus');
    return status === 'ON_ORDER';
  }

  render() {
    const { item, availabilityDetailActions } = this.props;
    const bib = item.getIn(['bib', 'briefInfo']);
    if (!bib) {
      return null;
    }

    const availabilityStatus = item.getIn(['bib', 'availability']);

    return (
      <div className="cp-holds-additional-brief-info">
        {this.renderItemDetails()}
        {this.renderVolume()}
        {this.renderCopy()}
        <ItemFormat bib={item.get('bib')} />
        <div className="cp-holds-availability-link">
          <AvailabilityBibBlock
            bib={item.get('bib')}
            availabilityStatus={availabilityStatus}
            availabilityDetailActions={availabilityDetailActions}
            showCheckDigitalAvailabilityButton={false}
            showAvailabilityStatus={this.isOnOrder()}
            showAvailabilityLink />
        </div>
      </div>
    );
  }
}

HoldsAdditionalBriefInfo.propTypes = {
  item: holdItemShape
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsAdditionalBriefInfo/HoldsAdditionalBriefInfo.jsx